export class MenuFilter {
  ruta?: string;
  titulo?: string;
  clase?: string;
  esEnlace?: boolean;
  roles?: string;
  submenu?: boolean;
}
